import { createBackgroundJob } from '../../utils/BackgroundJobs';
import ImportPixSellOrderRetryMutation from 'graphql/mutations/sales/ImportPixSellOrderRetryMutation.graphql';
import { ImportedPixSellOrder } from '../../graphql/entities';
import { getActionProps } from '../../utils/getActionProps';
import getClientMutationId from '../../utils/getClientMutationId';

const preparePayload = (props: any) => {
  const actionProps = getActionProps(props, 'importedPixSellOrders', ImportedPixSellOrder.workspaceUrl);

  return {
    clientMutationId: getClientMutationId(),
    ...actionProps,
  };
};

const retryImport = (props: any) => {
  const input = preparePayload(props);

  createBackgroundJob(ImportPixSellOrderRetryMutation, input, props, null, 'Retrying import', () => {
    if (window.location.pathname.startsWith(ImportedPixSellOrder.workspaceUrl || '')) {
      window.location.reload();
    }
  });
};

export const workspace = [
  {
    description: 'Retry',
    allowMultiple: false,
    call: retryImport,
    dataFromProps: 'actionEntities',
    actionReference: 'PIXSELL_ORDERS_IMPORT',
  },
];
